import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le l'update dell'event classification
 * @param {*} state
 * @param {*} action
 */
export default function icnEventClassificationReducer(state = initialState.eventClassification, action){

    switch(action.type)
    {
        case types.SEND_EVENTCLASSIFICATIONUPDATE_REQUEST:
            return {...state, error: null, isUpdating: true};
        case types.SEND_EVENTCLASSIFICATIONUPDATE_SUCCESS:
            return {...state, error: null, isUpdating: false};
        case types.SEND_EVENTCLASSIFICATIONUPDATE_ERROR:
            return {...state, error: action.data, isUpdating: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/icnEventClassificationReducer.js